export default [
	{
		path: ':portfolio/trade',
		name: 'portfolio.trade',
		redirect: {
			name: 'portfolio.trade.equity'
		},
		component: () =>
			import(
				'../../../../../components/dashboard/client/TradeComponent.vue'
			),
		children: [
			{
				path: 'equities',
				name: 'portfolio.trade.equity',
				component: () =>
					import(
						'../../../../../components/dashboard/client/trade/TradeLocalStocksComponent.vue'
					),
				meta: {
					allowedUsers: ['client']
				}
			},
			{
				path: 'fixed-income',
				name: 'portfolio.trade.fixed-income',
				component: () =>
					import(
						'../../../../../components/dashboard/client/trade/TradeFixedIncomeComponent.vue'
					),
				meta: {
					allowedUsers: ['client']
				}
			},
			{
				path: 'history',
				name: 'portfolio.trade.history',
				component: () =>
					import(
						'../../../../../components/dashboard/client/trade/TradeHistoryComponent.vue'
					),
				meta: {
					allowedUsers: ['client']
				}
			}
		]
	}
];
